import TextArea from 'antd/es/input/TextArea';

import { FormItemField } from '../../FormItemField';

import type { FormItemProps } from 'antd';

type TextAreaFieldProps = {
  label: string;
  fieldName: string | number | (string | number)[];
  rows?: number;
  rules?: FormItemProps['rules'];
  required?: boolean;
  disabled: boolean;
  maxLength?: number;
};

export const TextAreaField = ({
  label,
  fieldName,
  rows = 4,
  rules,
  required,
  disabled,
  maxLength,
}: TextAreaFieldProps) => (
  <FormItemField
    label={label}
    fieldName={fieldName}
    rules={rules}
    required={required}
    className="text-area-field"
  >
    <TextArea rows={rows} disabled={disabled} maxLength={maxLength} />
  </FormItemField>
);
